import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { LocalStorage } from '@services/local-storage/local-storage';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly _router: Router,
    private readonly _storageService: LocalStorage,
    private readonly _snackbar: SnackbarService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!navigator.onLine) {
      this._snackbar.notify('Please check your internet', 2);
      this._router.navigate(['auth/login']);
      return throwError(() => new Error('No Internet Connection'));
    }
    const token: string = this._storageService.getTokenAuth();
    const environ: string = this._storageService.getEnviorment();
    let req = request;
    if (token) {
      req = request.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          'ngrok-skip-browser-warning': '69420',
          'Access-Control-Allow-Credentials': 'true',
          Authorization: `Bearer ${token}`,
          environment: environ,
        },
      });
    }
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err.status === 401) {
          this._router.navigate(['/auth/login']);
        }
        // if (err.status === 403) {
        // 	this._dialog.closeAll();
        // 	setTimeout(() => {
        // 		this._dialog.open(SessionTimeoutPopupComponent, {
        // 			data: '',
        // 			width: '500px',
        // 			maxWidth: '90vw',
        // 		});
        // 	}, 100);
        // }
        // if (!navigator.onLine) {
        // 	this._snackbar.notify("Internet not wokring", 2)
        // }
        return throwError(() => err);
      })
    );
  }
}
